<div class="container-fluid">
	<div class="row align-items-center my-3">
		<div class="col">
			<h1 class="my-3">Listado de tomas de inventario</h1>
		</div>
		<div class="col-auto">
			<button class="btn btn-primary" (click)="show_new_stocktake = true">Nueva Toma de Inventario</button>
		</div>
	</div>
	<form (submit)="searchStockTakes()">
		<div class="card p-3">
			<div class="row mb-3">
				<div class="col-12 col-sm-6 col-md-3 form-group">
					<label>Sucursal</label>
					<select name="store_id" [(ngModel)]="store_id" class="form-control" required>
						<option value="0">Todas</option>
						<option *ngFor="let store of store_list" [value]="store.id">{{store.name | titlecase}}</option>
					</select>
				</div>
				<div class="col-12 col-sm-6 col-md-3 form-group">
					<label>&nbsp;</label>
					<button type="submit" class="btn btn-primary form-control">
						<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="1.3em" height="1.3em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 512 512"><path d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128c0-70.7 57.2-128 128-128c70.7 0 128 57.2 128 128c0 70.7-57.2 128-128 128z" fill="currentColor"/></svg>
						&nbsp;Buscar
					</button>
				</div>
			</div>
		</div>
	</form>

	<app-pagination [path]="path" [total_pages]="total_pages" [current_page]="current_page"></app-pagination>
	<div class="card p-3 mt-3">
		<app-loading [is_loading]="is_loading"></app-loading>
		<ng-template [ngIf]="stocktake_list.length <= 0">
			<h3 class="text-center">No hay tomas de inventario</h3>
		</ng-template>
		<div class="row d-none d-md-flex fw-bold border-bottom py-2 mb-2">
			<div class="col-md-3">Sucursal</div>
			<div class="col-md-3">Título de Inventario</div>
			<div class="col-md-2 text-center">Fecha</div>
			<div class="col-md-4 text-end">Acciones</div>
		</div>
		<div *ngFor="let stocktake of stocktake_list" class="row align-items-center border-bottom py-2">
			<div class="col-12 col-md-3">
				<a [routerLink]="['/edit-stocktake', stocktake.id]" class="fw-bold">
					{{stocktake.id}} - {{store_dictionary[stocktake.store_id].name}}
				</a>
			</div>
			<div class="col-12 col-md-3">
				<div class="text-muted">{{stocktake.name}}</div>
			</div>
			<div class="col-12 col-md-2 text-md-center">
				<small class="text-muted">{{stocktake.created | shortDate: 'full'}}</small>
			</div>
			<div class="col-12 col-md-4 text-end">
				<div class="row g-1">
					<div class="col-6 col-md-3">
						<button type="button" class="btn btn-primary w-100" (click)="deleteStocktake(stocktake)">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="m15.241 3.721l.293 2.029H19.5a.75.75 0 0 1 0 1.5h-.769l-.873 10.185c-.053.62-.096 1.13-.165 1.542c-.07.429-.177.813-.386 1.169a3.25 3.25 0 0 1-1.401 1.287c-.372.177-.764.25-1.198.284c-.417.033-.928.033-1.55.033h-2.316c-.622 0-1.133 0-1.55-.033c-.434-.034-.826-.107-1.198-.284a3.25 3.25 0 0 1-1.401-1.287c-.21-.356-.315-.74-.386-1.169c-.069-.413-.112-.922-.165-1.542L5.269 7.25H4.5a.75.75 0 0 1 0-1.5h3.966l.293-2.029l.011-.061c.182-.79.86-1.41 1.71-1.41h3.04c.85 0 1.528.62 1.71 1.41zM9.981 5.75h4.037l-.256-1.776c-.048-.167-.17-.224-.243-.224h-3.038c-.073 0-.195.057-.243.224zm1.269 4.75a.75.75 0 0 0-1.5 0v5a.75.75 0 0 0 1.5 0zm3 0a.75.75 0 0 0-1.5 0v5a.75.75 0 0 0 1.5 0z"/></svg>
						</button>
					</div>
					<div class="col-6 col-md-3">
						<a [routerLink]="['/edit-stocktake',stocktake.id]" class="btn btn-primary w-100"  *ngIf="stocktake.status != 'CLOSED'">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M18.58 2.944a2 2 0 0 0-2.828 0L14.107 4.59l5.303 5.303l1.645-1.644a2 2 0 0 0 0-2.829zm-.584 8.363l-5.303-5.303l-8.835 8.835l-1.076 6.38l6.38-1.077z"/></svg>
							<span class="d-none d-lg-inline">&nbsp;Editar</span>
						</a>
					</div>
					<div class="col-6 col-md-3">
						<a [routerLink]="['/view-stocktake',stocktake.id]" class="btn btn-primary w-100">
							<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M9.5 3A6.5 6.5 0 0 1 16 9.5c0 1.61-.59 3.09-1.56 4.23l.27.27h.79l5 5l-1.5 1.5l-5-5v-.79l-.27-.27A6.52 6.52 0 0 1 9.5 16A6.5 6.5 0 0 1 3 9.5A6.5 6.5 0 0 1 9.5 3m0 2C7 5 5 7 5 9.5S7 14 9.5 14S14 12 14 9.5S12 5 9.5 5"/></svg>
							<span class="d-none d-lg-inline">&nbsp;Ver</span>
						</a>
					</div>
					<div class="col-6 col-md-3">
						<button type="button" class="btn btn-primary w-100" (click)="showResume(stocktake)">
							<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"><path fill="currentColor" d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/></svg>
							<span class="d-none d-lg-inline">&nbsp;Resumen</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<app-modal [(show)]="show_new_stocktake" [biggest_posible]="true">
	<div class="row mb-3 p-3 mx-0">
		<div class="col-12 col-sm-6 col-md-4">
			<label>Sucursal</label>
			<select name="store_id" [(ngModel)]="new_stocktake_store_id" class="form-control" required>
				<option value="0">Seleccionar</option>
				<option *ngFor="let store of store_list" [value]="store.id">{{store.name | titlecase}}</option>
			</select>
		</div>
		<div class="col-12 col-sm-6 col-md-4">
			<div class="form-group">
				<label>Guia o Titulo de Inventario</label>
				<input type="text" class="form-control" name="stock_take_name" [(ngModel)]="new_stocktake_name" placeholder="Inventario por control">
			</div>
		</div>
		<div class="col-12 col-sm-6 col-md-4">
			<div class="form-group">
				<label>&nbsp;</label>
				<button type="button" class="btn btn-primary w-100" (click)="createStockTake()" [disabled]="new_stocktake_store_id == 0">
					<svg xmlns="http://www.w3.org/2000/svg" width="1.3em" height="1.3em" viewBox="0 0 20 20"><path fill="currentColor" fill-rule="evenodd" d="M10 2a8 8 0 0 0-8 8c0 4.418 3.582 8 8 8 4.418 0 8-3.582 8-8 0-4.418-3.582-8-8-8zm0 14a6 6 0 1 1 0-12 6 6 0 0 1 0 12zm-1-7h2V5h2v2h2v2h-2v2h-2V9H9z" clip-rule="evenodd"/></svg>
					&nbsp;Crear Inventario
				</button>
			</div>
		</div>
	</div>
</app-modal>


<app-modal [(show)]="show_resume" [closable]="true">
	<div class="p-3">
		<div class="row mb-3 p-3 mx-0">
			<div class="col-8 fw-bold">Articulos registrados</div>
			<div class="col-4 text-end">{{cresume.item_count | number}}</div>
			<div class="col-8 fw-bold" *ngIf="rest.current_permission.reports">Articulos totales</div>
			<div class="col-4 text-end" *ngIf="rest.current_permission.reports">{{cresume.db_qty_sum | number}}</div>
			<div class="col-8 fw-bold">Articulos Inventariados</div>
			<div class="col-4 text-end">{{cresume.stocktake_item_count | number}}</div>
			<div class="col-8 fw-bold">Total inventariados</div>
			<div class="col-4 text-end">{{cresume.real_qty_sum | number}}</div>
			<ng-container *ngIf="rest.current_permission.reports">
				<div class="col-8 fw-bold">Articulos con Sobrante</div>
				<div class="col-4 text-end">{{cresume.surplus_item_count | number}}</div>
				<div class="col-8 fw-bold">total Sobrantes</div>
				<div class="col-4 text-end">{{cresume.surplus_qty | number}}</div>
				<div class="col-8 fw-bold">Articulos con faltantes</div>
				<div class="col-4 text-end">{{cresume.missing_item_count | number}}</div>
				<div class="col-8 fw-bold">Total faltantes</div>
				<div class="col-4 text-end">{{cresume.missing_qty | number}}</div>
				<div class="col-8 fw-bold">Articulos con inventario correcto</div>
				<div class="col-4 text-end">{{cresume.ok_item_count | number}}</div>
				<div class="col-8 fw-bold">Total inventario correcto</div>
				<div class="col-4 text-end">{{cresume.ok_item_sum  | number}}</div>
			</ng-container>
		</div>
		<div class="row">
			<div class="col-6" *ngIf="selected_stocktake && rest.current_permission.add_stock && selected_stocktake.status != 'CLOSED' && cresume.ok_item_count != cresume.stocktake_item_count">
				<button type="button" class="btn btn-primary w-100" *ngIf="'ACTIVE' == selected_stocktake.status" (click)="applyStockDifferences()">Aplicar diferencias</button>
			</div>
			<div class="col-6" *ngIf="selected_stocktake && rest.current_permission.add_stock && selected_stocktake.status != 'CLOSED' && cresume.ok_item_count != cresume.stocktake_item_count">
				<button type="button" class="btn btn-primary w-100" *ngIf="'ACTIVE' == selected_stocktake.status" (click)="adjustStockValues()">Ajustar Inventarios</button>
			</div>
			<div class="col-12">
				<button type="button" class="btn btn-primary w-100 mt-3" (click)="show_resume=false">Cerrar</button>
			</div>
		</div>
	</div>
</app-modal>
